<script>
export default {
  props: {
    address: {
      required: true,
      type: Object
    }
  }
};
</script>

<template>
  <div>
    <div class="title-form mt-30">ENDEREÇO</div>

    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex px-1 md6 xs12>
        <v-text-field v-model="address.street" label="rua" disabled />
      </v-flex>

      <v-flex px-1 md6 xs12>
        <v-text-field v-model="address.street_number" label="número" disabled />
      </v-flex>
    </v-layout>

    <!-- CITY, STATE AND ZIPCODE -->
    <v-layout row>
      <v-flex px-1 md6 xs12>
        <v-text-field v-model="address.city" label="cidade" disabled />
      </v-flex>

      <v-flex px-1 md6 xs12>
        <v-text-field v-model="address.state" label="UF" disabled />
      </v-flex>

      <v-flex px-1 md6 xs12>
        <v-text-field
          v-model="address.zip_code"
          label="CEP"
          :mask="'#####-###'"
          disabled
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<style scoped>
.row {
  margin: 0;
}

.group-button {
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/FormData/AddressData.vue